import React from "react";
import { ToggleButton, styled } from "@mui/material";
import {
  getCurrentSizeProfile,
  responsiveFontSize,
} from "@common/components/Typography/style";

const FilterButton = styled(ToggleButton)(({ theme }) => ({
  borderRadius: "5rem",
  margin: "0 0.25rem",
  height: "2em",
  fontSize: getCurrentSizeProfile().small,
  ...responsiveFontSize(theme, "small"),

  fontWeight: "400",
  "&.Mui-selected": {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
}));

export default FilterButton;
